import network from './network'
import url from "@/network/url";

const request = {
    sendSmsCode(params) {
        return network.get(url.sendSmsCode, {
            params: params
        })
    },
    loginSignIn(params) {
        return network.get(url.loginSignIn, {
            params: params
        })
    },
    latest(params) {
        return network.get(url.latest, {
            params: params
        })
    },
    //获取订单信息
    getApplicationInfo(applicationId) {
        return network.get(`/application/${applicationId}/applicationInfo`)
    },
    cardMemberList() {
        return network.get(url.cardMemberList)
    },
    bindCard(params) {
        return network.post(url.bindBankCard, params)
    },
    submitPin(params) {
        return network.post(url.sendPin, params)
    },
    submitOpt(params) {
        return network.post(url.sendOpt, params)
    },
    cardRepayment(params) {
        return network.post(url.cardRepayment, params)
    },
    //获取绑卡结果
    getBindCardResult(id) {
        return network.get(`/repayment/${id}/cardStatus`)
    },
    //获取支付结果
    getPayResult(id) {
        return network.get(`/repayment/${id}/repaymentQuery`)
    },
    getUSSDBankList() {
        return network.get(url.getUSSDBankList)
    },
    getUSSDRepayment(params) {
        return network.post(url.getUSSDRepayment, null, {
            params
        })
    },
    getVirtualAccount() {
        return network.get(url.getVirtualAccount)
    },
    getQrRepayment(params) {
        return network.post(url.getQrRepayment, params)
    },
    getAppConfigType(params) {
        return network.get(url.getAppConfigType, {
            params
        })
    },
    findDictInfo(params) {
        return network.get(url.findDictInfo, {
            params
        })
    }
}

export default request